// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor{width:100%;position:relative;z-index:0;text-align:left}.text,.toolbar{border:1px solid #ccc}", ""]);
// Exports
module.exports = exports;
